class StateMachine {
  constructor() {
    this.store = {};
  }

  get state() {
    return this.store;
  }

  setState(newState) {
    this.store = {
      ...this.store,
      ...newState,
    };
  }
}

export default StateMachine;
